import { ReactNode } from "react"

interface CardsSectionProps {
  disabled?: boolean,
  icon?: ReactNode;
  title: string,
  titleAside?: ReactNode;
  children: ReactNode
  className?: string
  titleColor?:string
}

export const CardsSectionOld: React.FC<CardsSectionProps> = ({ title, children, disabled }) => {
  const disabledStyle = disabled ? "opacity-50" : "";
  return <div className={`flex flex-col gap-4 p-6 rounded-xl bg-section ${disabledStyle}`}>
    <h3 className="text-lg text-primary -mt-2 font-bold">{title}</h3>
    {children}
  </div>
}


export const CardsSection: React.FC<CardsSectionProps> = ({ title, icon, titleAside, children, disabled, className, titleColor = "text-primary" }) => {
  const disabledStyle = disabled ? "opacity-50" : "";
  return <div className={`flex flex-col gap-4 p-6 rounded-xl bg-section ${disabledStyle} ${className}`}>
    <div
      className={`flex items-center justify-between gap-3`}
    >
      <div className="flex items-center gap-4">
        {icon && icon}
        <div className={`text-lg ${titleColor} font-semibold`}>{title}</div>
      </div>
      {titleAside && (
        <div className="flex items-center">
          {titleAside}
        </div>
      )}
    </div>
    {children}
  </div>
}
